import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-historical-observations-modal',
  templateUrl: './historical-observations-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HistoricalObservationsModalComponent {
  public dialogRef = inject(MatDialogRef<HistoricalObservationsModalComponent>);

  public data = inject(MAT_DIALOG_DATA) as {
    observations: any[];
    serviceName: string;
  };

  close(): void {
    this.dialogRef.close();
  }
}
